module.exports = __webpack_public_path__ + "static/media/PersonA.de5702d9.png";